// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MarginFallback_wrapper__2pCKa"};